import React, { useEffect } from 'react';
import classNames from 'classnames';
import { Modal } from '../../Modal';
import "./styles.css";
export var Dialog = function (_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, onClose = _a.onClose, children = _a.children, applicationRootElement = _a.applicationRootElement, className = _a.className;
    var handleEscClick = function (event) {
        if (event.keyCode === 27 && onClose) {
            onClose();
        }
    };
    useEffect(function () {
        document.addEventListener('keydown', handleEscClick, false);
        return function () {
            document.removeEventListener('keydown', handleEscClick, false);
        };
    }, []);
    if (!open) {
        document.removeEventListener('keydown', handleEscClick, false);
        return null;
    }
    return (React.createElement(Modal, { open: open, className: classNames('lk-ui_modal', open && 'lk-ui_modal__open'), applicationRootElement: applicationRootElement },
        React.createElement("div", { className: classNames('lk-ui_dialog', className) },
            React.createElement("div", { className: 'lk-ui_dialog-backdrop', onClick: onClose }),
            children)));
};
